<!-- Header -->
<div class="sub-header" style="margin-bottom: 15px;">
    <div class="container" style="height: 100%;">
        <div class="controls-panel justify-content-between">
            <h5 style="margin:0;">PNC Report Date: {{this.contentResponse?.EFFECTIVE_DATE}}</h5>

            <div>
              <button type="button" class="btn btn-rbv" (click)="onSave()"
                [disabled]="loading">
                  <i class="fa fa-save mr-1"></i>
                  Save
              </button>

              <button type="button" class="btn btn-rbv ml-2" (click)="updateLocationModification()"
                [disabled]="loading">
                  <i class="fa fa-file-word-o"></i>
                  Download Word
              </button>
            </div>
        </div>
    </div>
</div>

<!-- Loading bar -->
<app-loader [loading]="loading"></app-loader>

<!-- List of Blocks -->
<div class="container" [hidden]="loading">
    <div class="flex-container" id="research-detail" *ngIf="contentResponse">
        <div *ngFor="let block of contentResponse?.BLOCKS; let i = index;">
            <!-- Static Text + Editable Text -->
            <section *ngIf="block.DATA.TYPE === ContentBlockType.STATIC_TEXT || block.DATA.TYPE === ContentBlockType.EDITABLE_TEXT"
                class="positionRelative" (mouseover)="displayCornerMenu(i)" (mouseout)="hideCornerMenu(i)"
                [ngClass]="{'highlight-block': contentResponse?.HIGHLIGHT_BLOCKS}"
                (click)="contentResponse?.HIGHLIGHT_BLOCKS ? addSection(i) : ''">
                <core-static-text (dblclick)="(block.DATA.TYPE === ContentBlockType.EDITABLE_TEXT && !block.DATA.IS_EDIT_MODE) ? toggleMode(i) : ''"
                (modeChange)="toggleMode(i)" [order]="block.ORDER" [text]="block.DATA.TEXT" [isEditMode]="contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE"></core-static-text>
                <div class="custom-btn-box" [hidden]="!contentResponse.BLOCKS[i].DATA.IS_SHOW_MENU">
                    <div class="btn-group optionButtonContainer" dropdown>
                        <button class="btn btn-rbv optionButton dropdown-toggle" dropdownToggle>
                            <i class="fa fa-ellipsis-v"></i>
                        </button>
                        <!-- Displaying sub menu items -->
                        <div class="drop-menu dropdown-menu-right" *dropdownMenu>
                            <a class="drop-item" (click)="moveUp(i)" *ngIf="(i != 0)">
                                <i class="fa fa-arrow-up drop-icon"></i>
                                <div class="item">Move Up</div>
                            </a>
                            <a class="drop-item" (click)="moveDown(i)" *ngIf="i != (contentResponse.BLOCKS.length - 1)">
                                <i class="fa fa-arrow-down drop-icon"></i>
                                <div class="item">Move Down</div>
                            </a>
                            <a class="drop-item" (click)="duplicate(i)">
                                <i class="fa fa-files-o drop-icon"></i>
                                <div class="item">Duplicate</div>
                            </a>
                            <a class="drop-item" (click)="removeBlock(i)">
                                <i class="fa fa-trash-o drop-icon"></i>
                                <div class="item">Remove</div>
                            </a>
                            <a class="drop-item" (click)="toggleMode(i)" *ngIf="block.DATA.TYPE === ContentBlockType.EDITABLE_TEXT">
                                <i class="{{contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE ? 'fa fa-eye drop-icon' : 'fa fa-pencil drop-icon'}}"></i>
                                <div class="item">{{contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE ? 'View' : 'Edit'}}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Map View -->
            <section *ngIf="block.DATA.TYPE === 'MAP'"
                class="positionRelative" (mouseover)="displayCornerMenu(i)" (mouseout)="hideCornerMenu(i)"
                [ngClass]="{'highlight-block': contentResponse?.HIGHLIGHT_BLOCKS}"
                (click)="contentResponse?.HIGHLIGHT_BLOCKS ? addSection(i) : ''">
                <core-location-map (dblclick)="block.DATA.IS_EDIT_MODE ? '' : toggleMode(i)"
                                   [imageData]="block.DATA.IMAGE_DATA"
                    [canvasJson]="block.DATA.CANVAS_JSON" [isEditMode]="contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE"
                    [index]="block.ORDER" [locationInfo]="block.DATA.LOCATION"></core-location-map>
                <div class="custom-btn-box" [hidden]="!contentResponse.BLOCKS[i].DATA.IS_SHOW_MENU">
                    <div class="btn-group optionButtonContainer" dropdown>
                        <button class="btn btn-rbv optionButton dropdown-toggle" dropdownToggle>
                            <i class="fa fa-ellipsis-v"></i>
                        </button>
                        <!-- Displaying sub menu items -->
                        <div class="drop-menu dropdown-menu-right" *dropdownMenu>
                            <a class="drop-item" (click)="moveUp(i)" *ngIf="(i != 0)">
                                <i class="fa fa-arrow-up drop-icon"></i>
                                <div class="item">Move Up</div>
                            </a>
                            <a class="drop-item" (click)="moveDown(i)" *ngIf="i != (contentResponse.BLOCKS.length - 1)">
                                <i class="fa fa-arrow-down drop-icon"></i>
                                <div class="item">Move Down</div>
                            </a>
                            <a class="drop-item" (click)="duplicate(i)">
                                <i class="fa fa-files-o drop-icon"></i>
                                <div class="item">Duplicate</div>
                            </a>
                            <a class="drop-item" (click)="removeBlock(i)">
                                <i class="fa fa-trash-o drop-icon"></i>
                                <div class="item">Remove</div>
                            </a>
                            <a class="drop-item" (click)="toggleMode(i)">
                                <i class="{{contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE ? 'fa fa-eye drop-icon' : 'fa fa-pencil drop-icon'}}"></i>
                                <div class="item">{{contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE ? 'View' : 'Edit'}}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <!-- PREPARED_STATEMENT_GENERAL -->
            <section *ngIf="block.DATA.TYPE === ContentBlockType.PREPARED_STATEMENT_GENERAL"
                class="positionRelative" (mouseover)="displayCornerMenu(i)" (mouseout)="hideCornerMenu(i)"
                [ngClass]="{'highlight-block': contentResponse?.HIGHLIGHT_BLOCKS}"
                (click)="contentResponse?.HIGHLIGHT_BLOCKS ? addSection(i) : ''">
                <core-blurb-text (dblclick)="block.DATA.IS_EDIT_MODE ? '' : toggleMode(i)"
                    (modeChange)="toggleMode(i)" (ft_ref_change)="updateFTRef($event)"
                    [order]="block.ORDER" [textAreaData]="block.DATA.TEXT"
                    [PS_IBIS_List]="contentResponse?.PS_IBIS ? contentResponse.PS_IBIS : []"
                    [PS_GENERAL_LIST]="contentResponse.PS_GENERAL"
                    [type]="block.DATA.TYPE" [isEditMode]="contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE"></core-blurb-text>
                <div class="custom-btn-box" [hidden]="!contentResponse.BLOCKS[i].DATA.IS_SHOW_MENU">
                    <div class="btn-group optionButtonContainer" dropdown>
                        <button class="btn btn-rbv optionButton dropdown-toggle" dropdownToggle>
                            <i class="fa fa-ellipsis-v"></i>
                        </button>
                        <!-- Displaying sub menu items -->
                        <div class="drop-menu dropdown-menu-right" *dropdownMenu>
                            <a class="drop-item" (click)="moveUp(i)" *ngIf="(i != 0)">
                                <i class="fa fa-arrow-up drop-icon"></i>
                                <div class="item">Move Up</div>
                            </a>
                            <a class="drop-item" (click)="moveDown(i)" *ngIf="i != (contentResponse.BLOCKS.length - 1)">
                                <i class="fa fa-arrow-down drop-icon"></i>
                                <div class="item">Move Down</div>
                            </a>
                            <a class="drop-item" (click)="duplicate(i)">
                                <i class="fa fa-files-o drop-icon"></i>
                                <div class="item">Duplicate</div>
                            </a>
                            <a class="drop-item" (click)="removeBlock(i)">
                                <i class="fa fa-trash-o drop-icon"></i>
                                <div class="item">Remove</div>
                            </a>
                            <a class="drop-item" (click)="toggleMode(i)">
                                <i class="{{contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE ? 'fa fa-eye drop-icon' : 'fa fa-pencil drop-icon'}}"></i>
                                <div class="item">{{contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE ? 'View' : 'Edit'}}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Street View -->
            <section *ngIf="block.DATA.TYPE === ContentBlockType.STREET_VIEW"
                class="positionRelative" (mouseover)="displayCornerMenu(i)" (mouseout)="hideCornerMenu(i)"
                [ngClass]="{'highlight-block': contentResponse?.HIGHLIGHT_BLOCKS}"
                (click)="contentResponse?.HIGHLIGHT_BLOCKS ? addSection(i) : ''">
                <core-location-street-view (dblclick)="block.DATA.IS_EDIT_MODE ? '' : toggleMode(i)"
                                           [imageData]="block.DATA.IMAGE_DATA"
                    [canvasJson]="block.DATA.CANVAS_JSON" [isEditMode]="contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE"
                    [index]="block.ORDER" [locationInfo]="block.DATA.LOCATION"></core-location-street-view>
                <div class="custom-btn-box" [hidden]="!contentResponse.BLOCKS[i].DATA.IS_SHOW_MENU">
                    <div class="btn-group optionButtonContainer" dropdown>
                        <button class="btn btn-rbv optionButton dropdown-toggle" dropdownToggle>
                            <i class="fa fa-ellipsis-v"></i>
                        </button>
                        <!-- Displaying sub menu items -->
                        <div class="drop-menu dropdown-menu-right" *dropdownMenu>
                            <a class="drop-item" (click)="moveUp(i)" *ngIf="(i != 0)">
                                <i class="fa fa-arrow-up drop-icon"></i>
                                <div class="item">Move Up</div>
                            </a>
                            <a class="drop-item" (click)="moveDown(i)" *ngIf="i != (contentResponse.BLOCKS.length - 1)">
                                <i class="fa fa-arrow-down drop-icon"></i>
                                <div class="item">Move Down</div>
                            </a>
                            <a class="drop-item" (click)="duplicate(i)">
                                <i class="fa fa-files-o drop-icon"></i>
                                <div class="item">Duplicate</div>
                            </a>
                            <a class="drop-item" (click)="removeBlock(i)">
                                <i class="fa fa-trash-o drop-icon"></i>
                                <div class="item">Remove</div>
                            </a>
                            <a class="drop-item" (click)="toggleMode(i)">
                                <i class="{{contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE ? 'fa fa-eye drop-icon' : 'fa fa-pencil drop-icon'}}"></i>
                                <div class="item">{{contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE ? 'View' : 'Edit'}}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Error Block -->
            <div class="default-container" *ngIf="block.DATA.TYPE === ContentBlockType.ERROR"
              [ngClass]="{'highlight-block': contentResponse?.HIGHLIGHT_BLOCKS}"
              (click)="contentResponse?.HIGHLIGHT_BLOCKS ? addSection(i) : ''">
                <div class="default-data">
                    <div class="warning-block">Block Warning</div>
                    <div style="margin: 10px 0;">{{block.DATA.MESSAGE}}</div>
                </div>
            </div>

            <!-- Editable Table -->
            <section *ngIf="block.DATA.TYPE === ContentBlockType.EDITABLE_TABLE"
                class="positionRelative" (mouseover)="displayCornerMenu(i)" (mouseout)="hideCornerMenu(i)"
                [ngClass]="{'highlight-block': contentResponse?.HIGHLIGHT_BLOCKS}"
                (click)="contentResponse?.HIGHLIGHT_BLOCKS ? addSection(i) : ''">
                <editable-text (dblclick)="block.DATA.IS_EDIT_MODE ? '' : toggleMode(i)" (modeChange)="toggleMode(i)"
                  [order]="block.ORDER" [text]="block.DATA.TEXT" [isEditMode]="contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE"
                  [tableType]="block.DATA.TABLE_TYPE"
                  [columns]="block.DATA.COLUMNS" (tableChange)="editableTableChange($event, i)"></editable-text>
                <div class="custom-btn-box" [hidden]="!contentResponse.BLOCKS[i].DATA.IS_SHOW_MENU">
                    <div class="btn-group optionButtonContainer" dropdown>
                        <button class="btn btn-rbv optionButton dropdown-toggle" dropdownToggle>
                            <i class="fa fa-ellipsis-v"></i>
                        </button>
                        <!-- Displaying sub menu items -->
                        <div class="drop-menu dropdown-menu-right" *dropdownMenu>
                            <a class="drop-item" (click)="moveUp(i)" *ngIf="(i != 0)">
                                <i class="fa fa-arrow-up drop-icon"></i>
                                <div class="item">Move Up</div>
                            </a>
                            <a class="drop-item" (click)="moveDown(i)" *ngIf="i != (contentResponse.BLOCKS.length - 1)">
                                <i class="fa fa-arrow-down drop-icon"></i>
                                <div class="item">Move Down</div>
                            </a>
                            <a class="drop-item" (click)="duplicate(i)">
                                <i class="fa fa-files-o drop-icon"></i>
                                <div class="item">Duplicate</div>
                            </a>
                            <a class="drop-item" (click)="removeBlock(i)">
                                <i class="fa fa-trash-o drop-icon"></i>
                                <div class="item">Remove</div>
                            </a>
                            <a class="drop-item" (click)="toggleMode(i)">
                                <i class="{{contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE ? 'fa fa-eye drop-icon' : 'fa fa-pencil drop-icon'}}"></i>
                                <div class="item">{{contentResponse.BLOCKS[i].DATA.IS_EDIT_MODE ? 'View' : 'Edit'}}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <!-- GOOGLE_SEARCH -->
            <section *ngIf="block.DATA.TYPE === ContentBlockType.GOOGLE_SEARCH"
                class="positionRelative" (mouseover)="displayCornerMenu(i)" (mouseout)="hideCornerMenu(i)"
                [ngClass]="{'highlight-block': contentResponse?.HIGHLIGHT_BLOCKS}"
                (click)="contentResponse?.HIGHLIGHT_BLOCKS ? addSection(i) : ''">
                <google-search [order]="block.ORDER" [index]="i"
                    [type]="block.DATA.TYPE"></google-search>
                <div class="custom-btn-box" [hidden]="!contentResponse.BLOCKS[i].DATA.IS_SHOW_MENU">
                  <div class="btn-group optionButtonContainer" dropdown>
                    <button class="btn btn-rbv optionButton dropdown-toggle" dropdownToggle>
                        <i class="fa fa-ellipsis-v"></i>
                    </button>
                    <!-- Displaying sub menu items -->
                    <div class="drop-menu dropdown-menu-right" *dropdownMenu>
                      <a class="drop-item" (click)="moveUp(i)" *ngIf="(i != 0)">
                        <i class="fa fa-arrow-up drop-icon"></i>
                        <div class="item">Move Up</div>
                      </a>
                      <a class="drop-item" (click)="moveDown(i)" *ngIf="i != (contentResponse.BLOCKS.length - 1)">
                        <i class="fa fa-arrow-down drop-icon"></i>
                        <div class="item">Move Down</div>
                      </a>
                      <a class="drop-item" (click)="removeBlock(i)">
                        <i class="fa fa-trash-o drop-icon"></i>
                        <div class="item">Remove</div>
                      </a>
                    </div>
                  </div>
                </div>
            </section>
        </div>

        <!-- Reference Footnote -->
        <section>
            <div class="footnote-list" *ngIf="contentResponse?.REFS?.length > 0;">
                <div class="footnote">
                    <div *ngFor="let refs of contentResponse?.REFS; let i = index; let first = first">
                        <div class="item">
                            <div class="row" id="{{first ? 'FT_QWKWSGVXUN' : refs.CODE}}">
                                <!-- Footnote Code -->
                                <div class="column col-md-2">
                                    <div>{{refs.CODE}}</div>
                                </div>

                                <!-- Footnote Reference -->
                                <div class="column col-md-10">
                                    <div class="removeMargin" [innerHtml]="refs.REFERENCE"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Download button -->
        <button class="btn btn-rbv" (click)="updateLocationModification()" type="submit"
            style="margin: 10px 0;">
            <i class="fa fa-file-word-o"></i>
            Download Word
        </button>
    </div>
</div>

<!-- Message To pick highlighted block -->
<div class="pick-block-msg" *ngIf="contentResponse?.HIGHLIGHT_BLOCKS">
  Pick a block after which new block will be inserted. Click 'Esc' to cancel.
</div>

<div class="floating-menu">
  <div class="block">
    <!-- Download button -->
    <button class="btn btn-rbv" (click)="updateLocationModification()" type="button">
      <i class="fa fa-file-word-o"></i>
      Download Word
    </button>

    <!-- Action -->
    <div class="btn-group w-100" dropdown>
      <button class="btn btn-rbv btn-rbv-dropdown mt-2" dropdownToggle>
        <i class="fa fa-plus"></i>
        Add Section
      </button>
      <!-- options -->
      <div class="drop-menu" style="width: 220px; right: 140px; top: 40px;">
        <div class="drop-item" (click)="highlightSection(ContentBlockType.EDITABLE_TEXT)">
          <div>Editable Text</div>
        </div>
        <div class="drop-item" (click)="highlightSection(ContentBlockType.PREPARED_STATEMENT_IBIS)"
          *ngIf="contentResponse && contentResponse?.PS_IBIS && contentResponse?.PS_IBIS.length > 0">
          <div>Prepared Statement IBIS</div>
        </div>
        <div class="drop-item" (click)="highlightSection(ContentBlockType.PREPARED_STATEMENT_GENERAL)"
          *ngIf="contentResponse && contentResponse?.PS_GENERAL && contentResponse?.PS_GENERAL.length > 0">
          <div>Prepared Statement General</div>
        </div>
        <div class="drop-item" (click)="highlightSection(ContentBlockType.MAP)">
          <div>Map</div>
        </div>
        <div class="drop-item" (click)="highlightSection(ContentBlockType.STREET_VIEW)">
          <div>Street View</div>
        </div>
        <div class="drop-item" (click)="highlightSection(ContentBlockType.EDITABLE_TABLE, ContentBlockTableType.DEMOGRAPHICS)">
          <div>Census Demographic</div>
        </div>
        <div class="drop-item" (click)="highlightSection(ContentBlockType.EDITABLE_TABLE, ContentBlockTableType.FINANCIALS)">
          <div>Census Financials</div>
        </div>
      </div>
    </div>

    <!-- Go Up button while scrolling -->
    <button class="btn btn-rbv mt-2" *ngIf="isShow" (click)="gotoTop()">
      <i class="fa fa-arrow-up"></i>
      Go Up
    </button>
  </div>
</div>
